import { isGuestAccessMode } from "../utils/guest";

// Prepares an API route by replacing parameters and adjusting for guest access mode
export function prepareApiRoute(route: string, params: Record<string, string | number>) {
  let preparedRoute = route;

  if (isGuestAccessMode()) {
    preparedRoute = preparedRoute.replace("internal_api", "scorm");
  }

  Object.keys(params).forEach(key => {
    const value = encodeURIComponent(params[key]);
    preparedRoute = preparedRoute.replace(`:${key}`, value.toString());
  });
  return preparedRoute;
}
